// src/pages/produccion/CumplimientoPlan.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

const RECETAS = [
  'Granola Original', 'Granola Ligera', 'Granola Chocolate', 'Granola Vainilla', 'Granola Maple',
  'Cereal Arándano', 'Cereal Quinoa', 'Cereal Chocolate', 'Cereal Maple',
  'Barra Original', 'Barra Ligera', 'Barra Chocolate',
];
const TURNOS = ['Matutino', 'Nocturno'];
const META = 95; // % — según la ficha del KPI

export default function CumplimientoPlan() {
  const [tab, setTab] = useState('captura');
  return (
    <div style={styles.paginaContenedor}>
      <h1 style={styles.tituloPagina}>Cumplimiento del Plan de Producción</h1>
      <p style={styles.subtituloPagina}>% Cumplimiento = Producción Real (Empaque) ÷ Producción Planeada · Meta: &gt;{META}%</p>
      <div style={styles.tabBar}>
        <button onClick={() => setTab('captura')} style={{ ...styles.tabBtn, ...(tab === 'captura' ? styles.tabBtnActivo : {}) }}>📝 Captura del Plan</button>
        <button onClick={() => setTab('resumen')} style={{ ...styles.tabBtn, ...(tab === 'resumen' ? styles.tabBtnActivo : {}) }}>📊 Resumen</button>
      </div>
      {tab === 'captura' ? <TabCaptura /> : <TabResumen />}
    </div>
  );
}

function TabCaptura() {
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
  const [turno, setTurno] = useState('Matutino');
  const [receta, setReceta] = useState(RECETAS[0]);
  const [cantidad, setCantidad] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  async function handleGuardar() {
    try {
      setGuardando(true);
      setMensaje(null);
      await api.post('/api/produccion/plan', {
        fecha, turno, sku: receta, cantidad_planeada: cantidad,
      });
      setMensaje({ tipo: 'ok', texto: '✓ Plan guardado correctamente.' });
      setCantidad('');
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo guardar el plan.' });
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div style={styles.tarjeta}>
      <p style={styles.notaPlan}>
        Transcribe aquí el plan de producción (F-PRO-25) por receta — si ya existe uno para la misma fecha/turno/receta, se actualiza en vez de duplicarse.
      </p>
      <div style={styles.grid3}>
        <Campo label="Fecha">
          <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} style={styles.input} />
        </Campo>
        <Campo label="Turno">
          <select value={turno} onChange={(e) => setTurno(e.target.value)} style={styles.input}>
            {TURNOS.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </Campo>
        <Campo label="Receta">
          <select value={receta} onChange={(e) => setReceta(e.target.value)} style={styles.input}>
            {RECETAS.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </Campo>
      </div>
      <Campo label="Cantidad Planeada (kg)">
        <input type="number" step="0.01" value={cantidad} onChange={(e) => setCantidad(e.target.value)} style={styles.input} />
      </Campo>
      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}
      <button onClick={handleGuardar} disabled={guardando} style={styles.botonGuardar}>
        {guardando ? 'Guardando...' : 'Guardar Plan'}
      </button>
    </div>
  );
}

const MESES = [
  ['01', 'Enero'], ['02', 'Febrero'], ['03', 'Marzo'], ['04', 'Abril'], ['05', 'Mayo'], ['06', 'Junio'],
  ['07', 'Julio'], ['08', 'Agosto'], ['09', 'Septiembre'], ['10', 'Octubre'], ['11', 'Noviembre'], ['12', 'Diciembre'],
];
function ultimoDiaDelMes(anio, mes) {
  return new Date(anio, parseInt(mes), 0).getDate();
}

function TabResumen() {
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [fDesde, setFDesde] = useState('');
  const [fHasta, setFHasta] = useState('');
  const [fMes, setFMes] = useState('');
  const [fAnio, setFAnio] = useState(new Date().getFullYear());
  const [fTurno, setFTurno] = useState('');
  const [fReceta, setFReceta] = useState('');

  async function cargar() {
    try {
      setCargando(true);
      const params = {};
      if (fDesde) params.desde = fDesde;
      if (fHasta) params.hasta = fHasta;
      if (fTurno) params.turno = fTurno;
      if (fReceta) params.receta = fReceta;
      const res = await api.get('/api/produccion/cumplimiento-resumen', { params });
      setRegistros(res.data.data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError('No se pudo cargar el resumen.');
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleMesChange(mes) {
    setFMes(mes);
    if (mes) {
      setFDesde(`${fAnio}-${mes}-01`);
      setFHasta(`${fAnio}-${mes}-${String(ultimoDiaDelMes(fAnio, mes)).padStart(2, '0')}`);
    }
  }
  function limpiarFiltros() {
    setFDesde(''); setFHasta(''); setFMes(''); setFTurno(''); setFReceta('');
  }

  const totalPlaneado = registros.reduce((s, r) => s + parseFloat(r.cantidad_planeada), 0);
  const totalProducido = registros.reduce((s, r) => s + parseFloat(r.producido), 0);
  const pctGlobal = totalPlaneado > 0 ? (totalProducido / totalPlaneado) * 100 : 0;
  const semaforo = pctGlobal >= META ? '#3E7C5A' : pctGlobal >= META - 10 ? '#C08A2B' : '#B23A48';

  return (
    <div>
      <div style={styles.kgrid}>
        <div style={{ ...styles.kcard, borderTop: `3px solid ${semaforo}` }}>
          <div style={styles.kLbl}>% Cumplimiento</div>
          <div style={{ ...styles.kVal, color: semaforo }}>{pctGlobal.toFixed(1)}%</div>
          <div style={styles.kSub}>meta: &gt;{META}%</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Producción Planeada</div>
          <div style={styles.kVal}>{totalPlaneado.toFixed(0)} kg</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Producción Real</div>
          <div style={styles.kVal}>{totalProducido.toFixed(0)} kg</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Líneas evaluadas</div>
          <div style={styles.kVal}>{registros.length}</div>
        </div>
      </div>

      <div style={styles.filtrosBar}>
        <FiltroFecha label="Desde" value={fDesde} onChange={(v) => { setFDesde(v); setFMes(''); }} />
        <FiltroFecha label="Hasta" value={fHasta} onChange={(v) => { setFHasta(v); setFMes(''); }} />
        <FiltroSel label="Mes" value={fMes} onChange={handleMesChange} options={[['', '—'], ...MESES]} />
        <div style={styles.filtroGrupo}>
          <label style={styles.filtroLabel}>Año</label>
          <input type="number" value={fAnio} onChange={(e) => setFAnio(e.target.value)} style={{ ...styles.filtroInput, width: '80px' }} />
        </div>
        <FiltroSel label="Turno" value={fTurno} onChange={setFTurno} options={[['', 'Todos'], ...TURNOS.map((t) => [t, t])]} />
        <FiltroSel label="Receta" value={fReceta} onChange={setFReceta} options={[['', 'Todas'], ...RECETAS.map((r) => [r, r])]} />
        <button onClick={cargar} style={styles.botonBuscar2}>Buscar</button>
        <button onClick={limpiarFiltros} style={styles.botonLimpiar}>Limpiar</button>
      </div>

      {cargando ? <div>Cargando...</div> : error ? <div style={{ color: '#B23A48' }}>{error}</div> : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Fecha</th><th style={styles.th}>Turno</th><th style={styles.th}>Receta</th>
                <th style={styles.th}>Planeado (kg)</th><th style={styles.th}>Producido (kg)</th><th style={styles.th}>% Cumplimiento</th>
              </tr>
            </thead>
            <tbody>
              {registros.map((r, i) => {
                const pct = parseFloat(r.cantidad_planeada) > 0 ? (parseFloat(r.producido) / parseFloat(r.cantidad_planeada)) * 100 : 0;
                const color = pct >= META ? '#3E7C5A' : pct >= META - 10 ? '#C08A2B' : '#B23A48';
                return (
                  <tr key={i}>
                    <td style={styles.td}>{new Date(r.fecha).toLocaleDateString('es-MX')}</td>
                    <td style={styles.td}>{r.turno}</td>
                    <td style={styles.td}>{r.receta}</td>
                    <td style={styles.td}>{parseFloat(r.cantidad_planeada).toFixed(2)}</td>
                    <td style={styles.td}>{parseFloat(r.producido).toFixed(2)}</td>
                    <td style={{ ...styles.td, fontWeight: 700, color }}>{pct.toFixed(1)}%</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {registros.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin registros — captura el Plan primero.</p>}
        </div>
      )}
    </div>
  );
}

function Campo({ label, children }) {
  return <div style={{ marginBottom: '14px' }}><label style={styles.label}>{label}</label>{children}</div>;
}
function FiltroSel({ label, value, onChange, options }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
function FiltroFecha({ label, value, onChange }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <input type="date" value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput} />
    </div>
  );
}

const styles = {
  paginaContenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42' },
  tituloPagina: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtituloPagina: { fontSize: '12px', color: '#8A7690', marginBottom: '16px' },
  tabBar: { display: 'flex', gap: '6px', borderBottom: '2px solid #E6DDD2', marginBottom: '20px' },
  tabBtn: { padding: '10px 20px', fontSize: '13px', fontWeight: 600, color: '#8A7690', background: 'none', border: 'none', borderBottom: '3px solid transparent', cursor: 'pointer', marginBottom: '-2px' },
  tabBtnActivo: { color: '#4A1E5C', borderBottom: '3px solid #4A1E5C' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', maxWidth: '620px' },
  notaPlan: { fontSize: '11px', color: '#8A7690', marginBottom: '14px', fontStyle: 'italic' },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px' },
  label: { display: 'block', fontSize: '11px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '5px' },
  input: { width: '100%', padding: '8px 10px', fontSize: '13px', border: '1px solid #E6DDD2', borderRadius: '7px', fontFamily: 'Inter, sans-serif', boxSizing: 'border-box' },
  mensaje: { fontSize: '13px', margin: '10px 0', fontWeight: 600 },
  botonGuardar: { marginTop: '6px', width: '100%', padding: '12px', fontSize: '14px', fontWeight: 700, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  kgrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '14px', marginBottom: '18px' },
  kcard: { background: '#fff', border: '1px solid #E6DDD2', borderTop: '3px solid #4A1E5C', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  kLbl: { fontSize: '11px', fontWeight: 500, color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '8px' },
  kVal: { fontSize: '24px', fontWeight: 700, color: '#2A1830' },
  kSub: { fontSize: '11px', color: '#8A7690', marginTop: '4px' },
  filtrosBar: { display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' },
  filtroGrupo: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filtroLabel: { fontSize: '10px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px' },
  filtroInput: { padding: '6px 8px', fontSize: '12px', border: '1px solid #E6DDD2', borderRadius: '6px', fontFamily: 'Inter, sans-serif' },
  botonBuscar2: { padding: '7px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  botonLimpiar: { padding: '7px 14px', fontSize: '12px', color: '#8A7690', background: 'transparent', border: '1px solid #E6DDD2', borderRadius: '6px', cursor: 'pointer' },
  tablaScroll: { overflowX: 'auto', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '2px solid #E6DDD2', color: '#6E4F80', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase', whiteSpace: 'nowrap' },
  td: { padding: '6px 10px', borderBottom: '1px solid #F0E9E0', whiteSpace: 'nowrap' },
};